import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  SdfFlagLayout, SdfIcon, SdfInput, SdfButton,
} from '@waypoint/react-components';
import { isNotBlank, isEnterKeyPressed } from '../../util/misc';

const OTPPage = (props) => {
  const {
    currentlySending,
    otp,
    setOTP,
    verifyOTP,
    requestNewCode,
    authenticatorFormat,
    otpReissueRemainingAttempts,
    otpDeadEndScenario,
    isAppView,
    intl,
    locale,
    signedInResponseType,
    otpVerifyResponseType,
    otpPageProps = {},
  } = props;
  const isOtpVerifySuccess =
    signedInResponseType === 'SIGNED_IN' || otpVerifyResponseType === 'SIGNED_IN';

  const isOTPEntered = !currentlySending && isNotBlank(otp) && !isOtpVerifySuccess;

  const otpMask = {
    mask: '#######',
    definitions: {
      // <any single char>: <same type as mask (RegExp, Function, etc.)>
      // defaults are '0', 'a', '\*'
      '#': /[0-9]/,
    },
  };

  const handleKeyPressOnNexIn = (event) => {
    if (event.charCode === 13 && isOTPEntered) {
      event.preventDefault();
      !currentlySending && verifyOTP();
    }
  };
  const otpAttemptsExceeded = otpReissueRemainingAttempts === 0;
  const {
    iconCheck,
    title1,
    title2,
    label,
    qrCodeImage,
    moreoptions1,
    moreoptions2,
    primaryButton,
    secondaryButton,
  } = otpPageProps;

  return (
    <div>
      <form onSubmit={ primaryButton.clickFunction }>
        <div id="frmLogin">
          <div>
            <div>
              <div className="md:font-medium md:not-italic text-md md:leading-md mt-3">
                <SdfFlagLayout>
                  { iconCheck && (
                    <SdfIcon
                      slot="graphic"
                      shape="square"
                      icon="brand-adp"
                      class="text-4xl text-brand-secondary shadow-2 rounded-md box-border"
                    />
                  ) }
                  { ' ' }
                  <FormattedMessage
                    id={ title1 }
                    defaultMessage="We sent a code to"
                    description="otp page title"
                  />
                  { authenticatorFormat }
                  { '. ' }
                  <br />
                  { title2 && (
                    <FormattedMessage
                      id={ title2 }
                      defaultMessage="Enter it within 10 minutes"
                      description="otp page title"
                    />
                  ) }
                </SdfFlagLayout>
              </div>
              <div
                id="otpform"
                className="flex-row flex-1 text-center pt-4"
              >
                { qrCodeImage ? (
                  <>
                    <img
                      src={ qrCodeImage }
                      alt="QR Code for ADP Mobile App"
                      className="mx-auto w-48 h-48 mt-4 mb-4"
                    />
                    <div className="text-heading-06 not-italic font-extrabold leading-tight leading-md mt-2 text-center">
                      <FormattedMessage
                        id="qrcode.stepup.request.body"
                        defaultMessage="Download the free mobile app"
                        description="QR code body text"
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <SdfInput
                      autoFocus
                      id="otp-page_passcode"
                      data-testid="otp-page_passcode"
                      type="text"
                      input-width="xs"
                      inputType="decimal"
                      autocomplete="one-time-code"
                      advancedMask={ otpMask }
                      label={ intl.formatMessage({
                        id: label,
                        defaultMessage: 'Passcode',
                        description: 'Passcode label',
                      }) }
                      maxlength={ 7 }
                      value={ otp }
                      onSdfInput={ eve => setOTP(eve.detail) }
                      onKeyPress={ handleKeyPressOnNexIn }
                    />
                    <br />
                    <br />
                  </>
                ) }
              </div>
              <div
                className="md:font-medium md:not-italic text-md md:leading-md mt-2"
                hidden={ otpAttemptsExceeded }
              >
                { moreoptions1 && (
                  <FormattedMessage
                    id={ moreoptions1 }
                    defaultMessage="Didn’t receive a notification?"
                    description="otp page title"
                  />
                ) }
                { ' ' }
                { moreoptions2 && (
                  <SdfButton
                    id="demo-component"
                    action="standard"
                    emphasis="tertiary"
                    size="sm"
                    variant="contained"
                    icon="nav-move-right"
                    icon-placement="after"
                    onClick={ () => requestNewCode() }
                    onKeyPress={ () => requestNewCode() }
                  >
                    <FormattedMessage
                      id={ moreoptions2 }
                      defaultMessage="More Options"
                      description="otp page title"
                    />
                  </SdfButton>
                ) }
              </div>
              <div
                className={
                  isAppView ?
                    'flex-row flex-1 mt-10 text-center' :
                    'flex md:flex-row-reverse mt-20 md:mt-8 flex-col items-center'
                }
              >
                { (!qrCodeImage || primaryButton) && (
                  <SdfButton
                    buttonStyle="link"
                    emphasis="primary"
                    data-testid={ primaryButton.id }
                    id={ primaryButton.id }
                    className={ isAppView ? 'w-full p-2' : primaryButton.className }
                    disabled={ !qrCodeImage ? !isOTPEntered || undefined : undefined }
                    size="lg"
                    onClick={ primaryButton.clickFunction }
                    onKeyPress={ handleKeyPressOnNexIn }
                  >
                    <span>
                      <FormattedMessage
                        id={ primaryButton.labelId }
                        defaultMessage={ primaryButton.defaultMessage }
                        description={ primaryButton.description }
                      />
                    </span>
                  </SdfButton>
                ) }
                { secondaryButton && (
                  <SdfButton
                    id={ secondaryButton.id }
                    data-testid={ secondaryButton.id }
                    className={ isAppView ? 'w-full p-2' : secondaryButton.className }
                    buttonStyle="link"
                    size="lg"
                    hidden={ otpAttemptsExceeded }
                    onClick={ secondaryButton.clickFunction }
                    onKeyPress={ (event) => {
                      isEnterKeyPressed(event.key) && secondaryButton.clickFunction();
                    } }
                  >
                    { ' ' }
                    { otpDeadEndScenario && (
                      <span id="cancel_span_link">
                        <FormattedMessage
                          id={ secondaryButton.labelId }
                          defaultMessage={ secondaryButton.defaultMessage }
                          description={ secondaryButton.description }
                        />
                      </span>
                    ) }
                    { !otpDeadEndScenario && (
                      <FormattedMessage
                        id={ secondaryButton.deadEndMessage }
                        defaultMessage={ secondaryButton.defaultMessage }
                        description={ secondaryButton.description }
                      />
                    ) }
                  </SdfButton>
                ) }
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

OTPPage.propTypes = {
  authenticatorFormat: PropTypes.string,
  currentlySending: PropTypes.bool,
  locale: PropTypes.string,
  otpDeadEndScenario: PropTypes.bool,
  setOTP: PropTypes.func.isRequired,
  verifyOTP: PropTypes.func.isRequired,
  requestNewCode: PropTypes.func.isRequired,
  otp: PropTypes.string,
  signedInResponseType: PropTypes.string,
  otpVerifyResponseType: PropTypes.string,
  otpReissueRemainingAttempts: PropTypes.number,
  otpPageProps: PropTypes.shape({
    iconCheck: PropTypes.bool,
    title1: PropTypes.string,
    title2: PropTypes.string,
    label: PropTypes.string,
    moreoptions1: PropTypes.string,
    moreoptions2: PropTypes.string,
    qrCodeImage: PropTypes.string,
    primaryButton: PropTypes.shape({
      id: PropTypes.string,
      description: PropTypes.string,
      labelId: PropTypes.string,
      defaultMessage: PropTypes.string,
      className: PropTypes.string,
      clickFunction: PropTypes.func,
    }),
    secondaryButton: PropTypes.shape({
      id: PropTypes.string,
      description: PropTypes.string,
      labelId: PropTypes.string,
      defaultMessage: PropTypes.string,
      className: PropTypes.string,
      clickFunction: PropTypes.func,
      deadEndMessage: PropTypes.string,
    }),
  }),

  result: PropTypes.shape({
    challenge: PropTypes.shape({
      type: PropTypes.string.isRequired,
    }),
    stepupSession: PropTypes.string.isRequired,
  }),
  isAppView: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default injectIntl(OTPPage);
